var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-drawer',{attrs:{"title":"我是标题","visible":_vm.show,"size":825}},[_c('div',{staticStyle:{"background-color":"yellow"},attrs:{"slot":"title"},slot:"title"},[_vm._v(" this is title "),_c('button',[_vm._v("hah")])]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }